module.exports = __webpack_public_path__ + "img/home_top.bak2.d1de090b.jpg";